import React, { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
    clearBetSlip,
    fetchBetSlipEvents,
    getBetDetails,
    startPlaceBetRequest,
} from '../../store/actions/betSlip';
import Tabs from './Tabs/Tabs';
import Loading from './Loading/Loading';
import PlacedTicket from './PlacedTicket/PlacedTicket';
import TicketDetails from './TicketDetails/TicketDetails';
import { timerCancel } from '../../store/actions/timer';
import { getTranslation } from '../../utils/translation';
import styles from './BetSlip.module.scss';
import { fetchProducerStatuses } from '../../store/actions/feed';
import { useProducerStatusToast } from '../../hooks/useProducerStatusToast';

const BetSlip = ({ isLive }) => {
    const dispatch = useDispatch();

    const { placedTicketDetails, isFetchingEvents, isTicketSubmitting, betLines, requestId } =
        useSelector(state => state.betSlip);

    useProducerStatusToast({ className: styles.producerToast, isLive });

    const verifyTicketTimeout = useRef(null);

    useEffect(() => {
        dispatch(fetchBetSlipEvents());
        dispatch(fetchProducerStatuses());
    }, []);

    useEffect(() => {
        if (requestId !== null) {
            const maxTimeout = betLines.some(betLine => betLine.isLive) ? 35 * 1000 : 10 * 1000;
            const elapsedTime = Date.now() - requestId.createDate;
            const remainingTimeout = maxTimeout - elapsedTime;

            dispatch(startPlaceBetRequest());

            verifyTicketTimeout.current = setTimeout(() => {
                dispatch(getBetDetails(requestId.requestId));
            }, remainingTimeout);
        } else {
            clearTimeout(verifyTicketTimeout.current);
        }

        return () => {
            clearTimeout(verifyTicketTimeout.current);
        };
    }, [requestId]);

    const resetBetSlip = () => {
        dispatch(clearBetSlip());
        dispatch(timerCancel());
    };

    return (
        <div className={styles.betSlip}>
            <Tabs />

            <Loading
                loading={isTicketSubmitting}
                title={getTranslation('betSlip.placeBets.betsInProcess')}
                description={getTranslation('betSlip.placeBets.loadingInfoMessage')}
            />

            <Loading
                loading={isFetchingEvents}
                title={getTranslation('betSlip.refresh.loadingTitle')}
                description={getTranslation('betSlip.refresh.loadingInfoMessage')}
            />

            {placedTicketDetails ? (
                <PlacedTicket resetBetSlip={resetBetSlip} />
            ) : (
                <TicketDetails resetBetSlip={resetBetSlip} />
            )}
        </div>
    );
};

export default BetSlip;
